/**
 * Shared SSE event matchers for shop kiosk meta refresh (G4).
 */

interface RealtimeEnvelopeMessage {
  type?: string;
  data?: Record<string, unknown>;
}

export function isKioskUpdated(message: RealtimeEnvelopeMessage): boolean {
  if (message.type === 'kiosk_updated') {
    return true;
  }
  const nestedType = message.data?.type;
  return nestedType === 'kiosk_updated';
}

export function readSalesPointIdFromRealtimeMessage(
  message: RealtimeEnvelopeMessage,
): number | undefined {
  const payload =
    message.type === 'customer_directory_updated' ||
    message.type === 'kiosk_updated' ||
    message.type === 'pickup_points_updated' ||
    message.data?.type === 'customer_directory_updated' ||
    message.data?.type === 'kiosk_updated' ||
    message.data?.type === 'pickup_points_updated'
      ? message.data
      : message.data;

  const raw = payload?.salesPointId ?? payload?.kioskId;
  if (typeof raw === 'number' && Number.isFinite(raw) && raw > 0) {
    return raw;
  }
  if (typeof raw === 'string' && raw.trim().length > 0) {
    const parsed = Number(raw);
    if (Number.isFinite(parsed) && parsed > 0) {
      return parsed;
    }
  }
  return undefined;
}

export function readTenantCodeFromBrandingMessage(
  message: RealtimeEnvelopeMessage,
): string | undefined {
  const payload = message.data;
  const raw = payload?.tenantCode;
  if (typeof raw === 'string' && raw.trim().length > 0) {
    return raw.trim();
  }
  return undefined;
}
